import gsap, {Linear} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../helpers/initScrollTrigger';
import {debounce} from 'throttle-debounce';

import {IS_TOUCH, BREAKPOINTS, isHomePage} from '../helpers/consts';

const CLONE_WORD_COUNT = 3;
const MAX_WIDTH = 10000;

export default () => {
	initScrollTrigger();
	const lineContainer = document.querySelectorAll('.js-line-scroll-container');

	lineContainer.forEach((container) => {
		const BASE_TIME = container.getAttribute('data-base-time');

		const startLine = container.querySelector('.js-line');
		const startWordsGroup = container.querySelector('.js-words-group-wrapper');


		for (let i = 0; i < CLONE_WORD_COUNT; i++) {
			const wordClone = startWordsGroup.cloneNode(true);
			startLine.appendChild(wordClone);
		}

		let lineWidth = 0;
		let time = 0;
		const lineClone = startLine.cloneNode(true);
		const startDirection = 'left';
		let timeline = null;
		let triggerInstance = null;
		let clonedLine = null;
		const scrollSpeed = 1;
		let timeScale = 1;

		const getLineTime = (elWidth) => {
			const windowW = document.body.offsetWidth;
			const sizeCoef = MAX_WIDTH / (MAX_WIDTH - windowW);
			const length = (elWidth / 1000);
			const final = (BASE_TIME / sizeCoef) * length;
			return final;
		};

		const pauseLineAnim = () => {
			timeline.pause();
			gsap.to(timeline, {timeScale: 1, overwrite: true});
		};

		const playLineAnim = () => {
			timeline.play();
		};

		const initTimeline = () => {
			timeline = new gsap.timeline({repeat: -1, paused: true,
				onReverseComplete() {
					this.totalTime(this.rawTime() + this.duration() * 10); // otherwise when the playhead gets back to the beginning, it'd stop. So push the playhead forward 10 iterations (it could be any number)
				}});
			const animateValue1 = startDirection === 'left' ? -lineWidth : lineWidth;
			const animateValue2 = startDirection === 'left' ? lineWidth : -lineWidth;

			timeline
				.fromTo(startLine, {rotation:0.01, x:0}, {force3D:true, x: animateValue1, ease: Linear.easeNone, duration: time}, 0)
				.fromTo(clonedLine, {rotation:0.01, x:animateValue2}, {force3D:true, x:0, ease: Linear.easeNone, duration: time}, 0)
				.set(startLine, {force3D:true, rotation:0.01, x: animateValue2})
				.to(clonedLine, {force3D:true, rotation:0.01, x: animateValue1, ease: Linear.easeNone, duration: time}, time)
				.to(startLine, {force3D:true, rotation:0.01, x: 0, ease: Linear.easeNone, duration: time}, time)
				.progress(1).progress(0)
				.play();

			const isSmallWidth = document.body.offsetWidth < BREAKPOINTS.md;
			let intervalId = null;
			if(isSmallWidth) return;

			let options = {
				trigger: document.querySelector('.js-bottom-line-wrapper'),
				start: () => {
					const top = -window.innerHeight * 0.5;
					return `${top} bottom`;
				},
				end: 'bottom bottom',
			}

			if(isHomePage) {
				options = {
					trigger: document.querySelector('.js-home-anim-container'),
					horizontal: true,
					start: 'left left',
					end: 'right right',
				}
			}

			triggerInstance = ScrollTrigger.create({
				...options,
				onUpdate: (self) => {
					// if(timeline.paused()) return;
					if(intervalId) clearInterval(intervalId);
					let velo = Math.abs(self.getVelocity()*0.05);

					velo = velo > 10 ? 10 : velo;
					timeScale = self.direction * velo;
					timeScale = timeScale > 1 || timeScale < -1 ? timeScale : self.direction;

					if(!timeline.paused()) {
						gsap.to(timeline, {timeScale: timeScale, overwrite: true});
					}

					intervalId = setInterval(() => {
						if(timeScale > 1) {
							timeScale = timeScale * 0.8;
							if(timeScale < 1.02) {
								timeScale = 1;
								clearInterval(intervalId);
							}
						}
						if(timeScale <  -1) {
							timeScale = timeScale * 0.8;
							if(timeScale > -1.02) {
								timeScale = -1;
								clearInterval(intervalId);
							}
						}
						gsap.to(timeline, {timeScale: timeScale, overwrite: true});
					}, 50);
				},
				onEnterBack: () => {
					gsap.to(timeline, {timeScale: timeScale, overwrite: true});
				},
				onLeave: () => {
					gsap.to(timeline, {timeScale: 1, overwrite: true});
				},
				onLeaveBack: () => {
					gsap.to(timeline, {timeScale: timeScale, overwrite: true});
				}
			});

		};

		const destroyTimeline = () => {
			if (triggerInstance) triggerInstance.kill();

			timeline.pause();
			timeline.kill();
			timeline = null;
		};

		const resize = () => {
			lineWidth = startWordsGroup.offsetWidth * (CLONE_WORD_COUNT + 1);
			time = getLineTime(lineWidth);

			if(timeline === null) {
				initTimeline();
			}
			else {
				destroyTimeline();
				initTimeline();
			}
		};

		lineClone.classList.add('cloned');
		container.appendChild(lineClone);

		clonedLine = container.querySelector('.js-line.cloned');

		resize();



		if (IS_TOUCH) {
			window.addEventListener('orientationchange', debounce(450, () => {
				resize();
			}));
		}
		else {
			window.addEventListener('resize', debounce(300, resize));
		}

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if(entry.isIntersecting) {
					playLineAnim();
				}
				else {
					pauseLineAnim();
				}
			});
		}, { threshold: 0 });
		observer.observe(container);
	});

};
